//  ***********************
//  $$ Document ready
//  ***********************
$(function() {

	window.windowWidth = window.innerWidth;
	window.windowHeight = window.innerHeight;

	window.isiPhone = navigator.userAgent.toLowerCase().indexOf('iphone');
	window.isiPad = navigator.userAgent.toLowerCase().indexOf('ipad');
	window.isiPod = navigator.userAgent.toLowerCase().indexOf('ipod');
	window.isAndroid = function(){ return /Android/i.test(navigator.userAgent); }
	window.getAndroidVersion = function(ua) {
		ua = (ua || navigator.userAgent).toLowerCase();
		var match = ua.match(/android\s([0-9\.]*)/);
		return match ? match[1] : false;
	};

	window.isIOS = false;
	if ( window.isiPhone > 0 || window.isiPad > 0 || window.isiPod > 0 ) {
		window.isIOS = true;
		$('html').addClass('iOS');
	}

	window.tablet = 640;
	window.tabletWide = 800;
	window.desktop = 1024;

	window.isTouch = false;
	if (('ontouchstart' in document.documentElement) || Modernizr.touchevents)
		window.isTouch = true;
	// isTouch = true;

	if (isTouch || Modernizr.touchevents) {
		$('html').addClass('touch');
	}

	// Detect IE11 and Add Modernizer-like Class to HTML Element
	if ( $.browser.msie && $.browser.version <= 11 )
		$( 'html' ).addClass( 'lt-ie12' );

	/// Detect Desktop/Mobile and Add Modernizer-like Class to HTML Element
	if ( $.browser.desktop )
		$( 'html' ).addClass( 'desktop' );
	else if ( $.browser.mobile )
		$( 'html' ).addClass( 'mobile' );

	if (window.isAndroid())
		$( 'html' ).addClass( 'android' )

	if (parseInt(getAndroidVersion(), 10) == 6)
		$( 'html' ).addClass( 'android6' )


	window.rtl = false;
	if ($('.layout-reversed').length)
		window.rtl = true;

	// Add functions here

	// responsive-helpers.js
	// bh.setHelpers(windowWidth, windowHeight);
	// bh.emptyLinks();

	// accessibility.js
	accessibility.init();

	// nav.js
	nav.init();

	// desktop-nav.js
	if (!isTouch && windowWidth >= desktop) {
		desktopNav.init();
	}

	// dropdowns.js
	dd.init();

	// social-popups.js
	socialPopups.init();

	// social-links.js
	socialLinks.init();

	// slider.js
	slider.init();

	// forms.js
	form.init();

	// ellipsis.js
	ellipsis.init();

	// ellipsis-new.js
	ellipsisNew.init();

	// filter.js
	filter.init();

	// pagination.js
	pagination.init();
	lazyScroll.init();

	// search.js
	search.init();

	// interactive-map.js
	window.vrMap = new InteractiveMap();

	// text.js
	text.init();

	// backToTop.js
	backToTop.init();

	// accordion.js
	accordion.init();

	// download-app-buttons.js
	downloadApp.init();

	// accordionTabs.js
    accordionTabs.init();

    // accordions-reskin.js
    accordionHandler.init();

	// trains.js
	trains.init();

	// product-page.js
	productPage.init();

	// product-overlay.js
	overlay.init();

	// dateTimePicker.js
	dateTimePicker.init();

	// googleMap.js
	googleMap.init();

	// customScrollbar.js
	customScrollbar.init();

	// supScripts.js
	supScripts.init();

	// open-login.js
	openLogin.init();

	// cookies.js
	cookies.init();

	// treats.js
	treat.init();

	// validation.js
	validation.init();

	//  tags.js
 	tags.init();

 	// zoom.js
 	zoom.init();

 	// twitter-feed.js
 	twitterFeed.init();

 	// weather.js
 	weather.init();

 	// videos.js
 	videos.init();

 	// modal.js
 	modal.init();

 	// modal-product.js
 	modalProduct.init();

	// widgetCarousel.js
 	widgetCarousel.init();

	// stylists.js
 	//stylists.init();
	 
 	// wear.js
	wearTab.init();

	// full-bleed-img-carousel.js
 	fullImgSlide.init();

 	// standard-product-list.js
 	productList.init();

 	// sidenav.js
 	sidenav.init();

 	// hero-nav.js
 	heroNav.init();

	// gallery.js
 	gallery.init();

	// Modal GDPR
	gdprModal.init();

	//Update Details gdpr
	gdprDetails.init();

	// Brands page functionality - brands.js
	brands.init();

	// Registration overlay - registration-modal.js
	resgistrationModal.init();

	termsConditionsModal.init();
});
